import { BodyText, HeadingH2 } from '@dreamstack/feature-components/src/layout/Texts'
import { cn } from '@dreamstack/util/src/cn'
import * as React from 'react'

export const TextContainer = ({
  className,
  children,
  ...rest
}: React.PropsWithChildren<{ className?: string }>) => (
  <div
    className={cn('col-span-full mb-px-24 md:col-span-6', className)}
    {...rest}
  >
    {children}
  </div>
)

export const FormContainer = ({
  className,
  children,
  ...rest
}: React.PropsWithChildren<{ className?: string }>) => (
  <div className={cn('col-span-full md:col-span-6', className)} {...rest}>
    {children}
  </div>
)

export const StyledHeadingH2 = ({
  className,
  children,
  ...rest
}: {
  className?: string
  children?: React.ReactNode
  [key: string]: any
}) => (
  <HeadingH2
    className={cn('col-span-full mb-px-24 md:mb-px-48', className)}
    {...rest}
  >
    {children}
  </HeadingH2>
)

export const StyledBodyText = ({
  className,
  children,
  ...rest
}: {
  className?: string
  children?: React.ReactNode
  [key: string]: any
}) => (
  <BodyText className={cn('whitespace-pre-line', className)} {...rest}>
    {children}
  </BodyText>
)
